export const merSETALAI = 'merSETALAI';
export const InterventionTypes = merSETALAI + '/InterventionTypes';
export const BeeCategories = merSETALAI + '/BEECategories'
export const InterventionTitles = merSETALAI + '/InterventionTitles';
export const SkillsProgrammeCodes = merSETALAI + '/SkillsProgrammeCodes';
export const SkillsSetCodes = merSETALAI + '/SkillsSetCodes';
export const FundingCodes = merSETALAI + '/FundingCodes';
export const CategoryInterventions = merSETALAI + '/CategoryInterventions';